const map = require('mn-utils/map');

const STATUSES_LIST = [
  'payment_link',
  'terminal',
  'online',
  'refund'
];

module.exports = {
  name: 'transactionType',
  placeholder: 'Transaction type',
  list: map(STATUSES_LIST, (id) => ({id})),
};
